import {BiCategory, BiLink, BiListPlus, BiSolidOffer} from "react-icons/bi";
import {BsCalendarEventFill, BsFileRuledFill, BsMenuButtonWideFill} from "react-icons/bs";
import {
    FaComments,
    FaFileInvoiceDollar,
    FaMoneyCheck,
    FaQuestion,
    FaRegFileImage,
    FaShippingFast,
    FaSms
} from "react-icons/fa";
import {
    MdAccountBox,
    MdArticle,
    MdContactPhone,
    MdDashboard, MdDesignServices,
    MdDiscount,
    MdDisplaySettings,
    MdHome,
    MdOutlineCategory,
    MdOutlinePages,
    MdPermMedia,
    MdSettings,
    MdWarehouse
} from "react-icons/md";
import {
    RiAdminFill,
    RiCalendarEventLine,
    RiUserFill,
    RiUserSettingsFill,
    RiUserShared2Fill,
    RiUserStarFill
} from "react-icons/ri";
import {ImUsers} from "react-icons/im";
import {TfiLayoutSlider} from "react-icons/tfi";
import PanelPaths from "@router/paths/panel";
import ProjectPermissions from "../roles/ProjectPermissions";
import projectPermissions from "../roles/ProjectPermissions";
import {HiPhoto} from "react-icons/hi2";
import {File, PlayCircle} from "react-feather";
import {FiUsers} from "react-icons/fi";
import {GiDoorHandle, GiSteelDoor} from "react-icons/gi";
import {SiBrandfolder, SiReaddotcv} from "react-icons/si";
import {PiUsersThree} from "react-icons/pi";
import {TbAffiliateFilled, TbBrandCampaignmonitor, TbCategory2} from "react-icons/tb";
import {CiDiscount1, CiHashtag} from "react-icons/ci";
import {GrCatalog, GrCatalogOption, GrServices, GrTransaction} from "react-icons/gr";
import {AiOutlineForm} from "react-icons/ai";
import {HiVariable} from "react-icons/hi";
import {CgEye} from "react-icons/cg";


const adminPanelSideBar = [
    {
        id: "dashboard",
        title: "Dashboard",
        type: "item",
        icon: <MdDashboard size={22}/>,
        navLink: PanelPaths.dashboard,
        roles: [],
        active: true,
        permissions: [projectPermissions.dashboard, projectPermissions.customerPerms],
    },
    {
        id: "admin_products_features",
        title: "Features",
        type: "item",
        icon: <MdOutlineCategory size={22}/>,
        navLink: PanelPaths.admin.productsFeatures,
        roles: [],
        active: true,
        permissions: [projectPermissions.features],
    },
    {
        id: "admin_products_attribute",
        title: "Attribute",
        type: "item",
        icon: <TbCategory2 size={22}/>,
        navLink: PanelPaths.admin.attribute(),
        roles: [],
        active: true,
        permissions: [projectPermissions.attribute],
    },
    {
        id: "admin_customer_club",
        title: "CustomerClub",
        type: "collapse",
        icon: <PiUsersThree size={22}/>,
        roles: [],
        active: true,
        permissions: [projectPermissions.club, projectPermissions.clubCampaign, projectPermissions.rating],
        children: [
            {
                id: "admin_club",
                title: "Clubs",
                type: "item",
                icon: <TbBrandCampaignmonitor size={20}/>,
                navLink: PanelPaths.admin.customerClub.clubs,
                roles: [],
                active: true,
                permissions: [projectPermissions.clubCampaign],
            },
            {
                id: "admin_rating",
                title: "Rating",
                type: "item",
                icon: <CiDiscount1 size={20}/>,
                navLink: PanelPaths.admin.customerClub.rating,
                roles: [],
                active: true,
                permissions: [projectPermissions.rating],
            },
            {
                id: "admin_event",
                title: "event",
                type: "item",
                icon: <RiCalendarEventLine size={20}/>,
                navLink: PanelPaths.admin.customerClub.event,
                roles: [],
                active: true,
                permissions: [projectPermissions.club],
            },
        ]
    },
    {
        id: "admin_manage_products",
        title: "ManageProducts",
        type: "collapse",
        icon: <File size={22}/>,
        roles: [],
        active: true,
        permissions: [projectPermissions.product, projectPermissions.productCategory, projectPermissions.productFeature, projectPermissions.productGroupOffer],
        children: [
            {
                id: "admin_products_categories",
                title: "Categories",
                type: "item",
                icon: <BiCategory size={20}/>,
                navLink: PanelPaths.admin.productsCategories,
                roles: [],
                active: true,
                permissions: [projectPermissions.productCategory],
            },
            {
                id: "admin_products",
                title: "Products",
                type: "item",
                icon: <BiListPlus size={20}/>,
                navLink: PanelPaths.admin.productsList,
                roles: [],
                active: true,
                permissions: [projectPermissions.product],
            },
            {
                id: "admin_products_group_offer",
                title: "groupOffer",
                type: "item",
                icon: <BiSolidOffer size={20}/>,
                navLink: PanelPaths.admin.productGroupOffer,
                roles: [],
                active: true,
                permissions: [projectPermissions.productGroupOffer],
            }
        ]
    },
    /*{
        id: "admin_manage_doors",
        title: "ManageDoors",
        type: "collapse",
        icon: <GiSteelDoor size={22}/>,
        roles: [],
        permissions: [projectPermissions.door, projectPermissions.doorCategory],
        children: [
            {
                id: "admin_doors_categories",
                title: "Categories",
                type: "item",
                icon: <BiCategory size={20}/>,
                navLink: PanelPaths.admin.doorsCategories,
                roles: [],
                permissions: [projectPermissions.doorCategory],
            },
            {
                id: "admin_doors",
                title: "doors",
                type: "item",
                icon: <BiListPlus size={20}/>,
                navLink: PanelPaths.admin.doorsList,
                roles: [],
                permissions: [projectPermissions.door],
            }
        ]
    },*/
    {
        id: "admin_manage_articles",
        title: "ManageArticles",
        type: "collapse",
        icon: <MdArticle size={22}/>,
        roles: [],
        active: true,
        permissions: [projectPermissions.articleCategory, projectPermissions.article],
        children: [
            {
                id: "admin_article_categories",
                title: "Categories",
                type: "item",
                icon: <BiCategory size={20}/>,
                navLink: PanelPaths.admin.articlesCategories,
                roles: [],
                active: true,
                permissions: [projectPermissions.articleCategory],
            },
            {
                id: "admin_articles",
                title: "Articles",
                type: "item",
                icon: <BiListPlus size={20}/>,
                navLink: PanelPaths.admin.articlesList,
                roles: [],
                active: true,
                permissions: [projectPermissions.article],
            }
        ]
    },
    {
        id: "admin_manage_services",
        title: "ManageServices",
        type: "collapse",
        icon: <MdDesignServices size={22}/>,
        roles: [],
        active: true,
        permissions: [projectPermissions.serviceCategories, projectPermissions.services],
        children: [
            {
                id: "admin_services_categories",
                title: "Categories",
                type: "item",
                icon: <BiCategory size={20}/>,
                navLink: PanelPaths.admin.serviceCategories,
                roles: [],
                active: true,
                permissions: [projectPermissions.serviceCategories],
            },
            {
                id: "admin_services",
                title: "Services",
                type: "item",
                icon: <GrServices size={20}/>,
                navLink: PanelPaths.admin.servicesList,
                roles: [],
                active: true,
                permissions: [projectPermissions.services],
            }
        ]
    },
    {
        id: "admin_manage_catalog",
        title: "ManageCatalogs",
        type: "collapse",
        icon: <GrCatalogOption size={22}/>,
        roles: [],
        active: true,
        permissions: [projectPermissions.catalogCategories, projectPermissions.catalog],
        children: [
            {
                id: "admin_catalog_categories",
                title: "Categories",
                type: "item",
                icon: <BiCategory size={20}/>,
                navLink: PanelPaths.admin.catalogCategories,
                roles: [],
                active: true,
                permissions: [projectPermissions.catalogCategories],
            },
            {
                id: "admin_catalogs",
                title: "catalog",
                type: "item",
                icon: <GrCatalog size={20}/>,
                navLink: PanelPaths.admin.catalogsList,
                roles: [],
                active: true,
                permissions: [projectPermissions.catalog],
            }
        ]
    },
    {
        id: "admin_manage_website",
        title: "ManageWebsite",
        type: "collapse",
        icon: <MdDisplaySettings size={22}/>,
        roles: [],
        active: true,
        permissions: [projectPermissions.sliderManagement, projectPermissions.bannerManagement, projectPermissions.faqManagement, projectPermissions.guideManagement, projectPermissions.menuManagement, ProjectPermissions.settingManagement, ProjectPermissions.customerBrand, ProjectPermissions.tags],
        children: [
            {
                id: "admin_manage_website_home",
                title: "Home",
                type: "collapse",
                icon: <MdHome size={20}/>,
                roles: [],
                active: true,
                permissions: [projectPermissions.sliderManagement, projectPermissions.bannerManagement],
                children: [
                    {
                        id: "admin_manage_website_sliders",
                        title: "Sliders",
                        type: "item",
                        icon: <TfiLayoutSlider size={20}/>,
                        navLink: PanelPaths.admin.websiteSliders,
                        roles: [],
                        active: true,
                        permissions: [projectPermissions.sliderManagement],
                    },
                    {
                        id: "admin_manage_website_banner",
                        title: "Banner",
                        type: "item",
                        icon: <FaRegFileImage size={20}/>,
                        navLink: PanelPaths.admin.websiteBanners,
                        roles: [],
                        active: true,
                        permissions: [projectPermissions.bannerManagement],
                    },
                    /*    {
                                           id: "admin_manage_website_catalogue",
                                           title: "catalogue",
                                           type: "item",
                                           icon: <FaRegFileImage size={20}/>,
                                           navLink: PanelPaths.admin.websiteCatalogue,
                                           roles: [],
                                           permissions: [ProjectPermissions.settingManagement],
                                       },
                                       {
                                           id: "admin_manage_website_products_category_banners",
                                           title: "ProductCategoryBanners",
                                           type: "item",
                                           icon: <TfiLayoutSliderAlt size={20}/>,
                                           navLink: PanelPaths.admin.websiteProductCategoryBanners,
                                           roles: [],
                                           permissions: [projectPermissions.bannerManagement],
                                       },*/
                ]
            },
            {
                id: "admin_manage_website_faq",
                title: "FAQ",
                type: "item",
                icon: <FaQuestion size={20}/>,
                navLink: PanelPaths.admin.websiteFaq,
                roles: [],
                active: true,
                permissions: [projectPermissions.faqManagement],
            },
            {
                id: "admin_manage_website_guide",
                title: "purchaseGuide",
                type: "item",
                icon: <FaQuestion size={20}/>,
                navLink: PanelPaths.admin.websiteGuide,
                roles: [],
                active: true,
                permissions: [projectPermissions.guideManagement],
            },
            {
                id: "admin_manage_website_menu",
                title: "Menu",
                type: "item",
                icon: <BsMenuButtonWideFill size={20}/>,
                navLink: PanelPaths.admin.websiteMenu,
                roles: [],
                active: true,
                permissions: [projectPermissions.menuManagement],
            },
            {
                id: "admin_manage_website_settings",
                title: "Settings",
                type: "item",
                icon: <MdSettings size={20}/>,
                navLink: PanelPaths.admin.websiteSettings,
                roles: [],
                active: true,
                permissions: [ProjectPermissions.settingManagement],
            },
            {
                id: "admin_customer-brand",
                title: "partiesToTheContract",
                type: "item",
                icon: <FiUsers size={20}/>,
                navLink: PanelPaths.admin.customerBrand,
                roles: [],
                active: true,
                permissions: [ProjectPermissions.customerBrand],
            },
            {
                id: "admin_brand",
                title: "Brand",
                type: "item",
                icon: <SiBrandfolder size={20}/>,
                navLink: PanelPaths.admin.brand,
                roles: [],
                active: true,
                permissions: [ProjectPermissions.brand],
            },
            {
                id: "admin_tags",
                title: "tags",
                type: "item",
                icon: <CiHashtag size={20}/>,
                navLink: PanelPaths.admin.tags,
                roles: [],
                active: true,
                permissions: [ProjectPermissions.tags],
            },
            {
                id: "admin_commercial_partners",
                title: "CommercialPartners",
                type: "item",
                icon: <TbAffiliateFilled size={20}/>,
                navLink: PanelPaths.admin.commercialPartners,
                roles: [],
                active: true,
                permissions: [ProjectPermissions.commercialPartners],
            },
        ]
    },
    {
        id: "admin_manage_users",
        title: "ManageUsers",
        type: "collapse",
        icon: <ImUsers size={22}/>,
        roles: [],
        active: true,
        permissions: [ProjectPermissions.rolesManagement, ProjectPermissions.customerManagement, ProjectPermissions.staffManagement],
        children: [
            {
                id: "admin_roles",
                title: "Roles",
                type: "item",
                icon: <RiUserSettingsFill size={20}/>,
                navLink: PanelPaths.admin.roles,
                roles: [],
                active: true,
                permissions: [ProjectPermissions.rolesManagement],
            },
            {
                id: "admin_customers",
                title: "Customers",
                type: "item",
                icon: <RiUserShared2Fill size={20}/>,
                navLink: PanelPaths.admin.customers,
                roles: [],
                active: true,
                permissions: [ProjectPermissions.customerManagement],
            },
            {
                id: "admin_personnel",
                title: "Personnel",
                type: "item",
                icon: <RiUserStarFill size={20}/>,
                navLink: PanelPaths.admin.personnel,
                roles: [],
                active: true,
                permissions: [ProjectPermissions.staffManagement],
            }
        ]
    },
    {
        id: "sms_setting",
        title: "SmsSetting",
        type: "item",
        icon: <FaSms size={22}/>,
        roles: [],
        active: true,
        permissions: [ProjectPermissions.smsManagement],
        children: [
            {
                id: "sms_setting_admin",
                title: "admin",
                type: "item",
                icon: <RiAdminFill size={20}/>,
                navLink: PanelPaths.admin.adminSmsSetting,
                roles: [],
                active: true,
                permissions: [ProjectPermissions.smsManagement],
            },
            {
                id: "sms_setting_customer",
                title: "Customer",
                type: "item",
                icon: <RiUserFill size={20}/>,
                navLink: PanelPaths.admin.customerSmsSetting,
                roles: [],
                active: true,
                permissions: [ProjectPermissions.smsManagement],
            }
        ]
    },
    {
        id: "admin_manage_media",
        title: "ManageMedia",
        type: "item",
        icon: <MdPermMedia size={22}/>,
        navLink: PanelPaths.admin.mediaImages,
        roles: [],
        active: true,
        permissions: [ProjectPermissions.mediaManagement]
    },
    {
        id: "admin_warehouse",
        title: "warehouse",
        type: "item",
        icon: <MdWarehouse size={22}/>,
        navLink: PanelPaths.admin.wareHouse,
        roles: [],
        active: true,
        permissions: [ProjectPermissions.warehouse],
    },
    {
        id: "admin_orders",
        title: "Orders",
        type: "item",
        icon: <BsFileRuledFill size={22}/>,
        navLink: PanelPaths.orders,
        roles: [],
        active: true,
        permissions: [ProjectPermissions.canViewCoWorkerOrderList, ProjectPermissions.canViewCustomerOrderList, projectPermissions.customerPerms],
    },
    /*{
        id: "production_management",
        title: "productionManagement",
        type: "item",
        icon: <ImBoxAdd size={22}/>,
        navLink: PanelPaths.admin.productionManagement,
        roles: [],
        permissions: [projectPermissions.productionManagement],
    },
    {
        id: "production_reports",
        title: "ProductionReports",
        type: "item",
        icon: <HiDocumentReport size={22}/>,
        navLink: PanelPaths.admin.productionReports,
        roles: [],
        permissions: [projectPermissions.productionManagement, projectPermissions.canViewPersonnelLogs],
    },*/
    {
        id: "admin_invoices",
        title: "Invoices",
        type: "item",
        icon: <FaFileInvoiceDollar size={22}/>,
        navLink: PanelPaths.admin.invoices,
        roles: [],
        active: true,
        permissions: [ProjectPermissions.canViewInvoicesList],
    },
    {
        id: "admin_transaction",
        title: "transaction",
        type: "item",
        icon: <GrTransaction size={22}/>,
        navLink: PanelPaths.admin.transaction,
        roles: [],
        active: true,
        permissions: [ProjectPermissions.transaction],
    },
    {
        id: "admin_coupons",
        title: "Coupons",
        type: "item",
        icon: <MdDiscount size={22}/>,
        navLink: PanelPaths.admin.coupons,
        roles: [],
        active: true,
        permissions: [ProjectPermissions.couponManagement],
    },
    {
        id: "admin_stories",
        title: "stories",
        type: "item",
        icon: <PlayCircle size={22}/>,
        navLink: PanelPaths.admin.websiteStories,
        roles: [],
        active: true,
        permissions: [ProjectPermissions.stories],
    },
    {
        id: "admin_manage_website_gallery",
        title: "gallery",
        type: "item",
        icon: <FaRegFileImage size={20}/>,
        navLink: PanelPaths.admin.websiteGallery,
        roles: [],
        active: true,
        permissions: [ProjectPermissions.galleries],
    },
    {
        id: "admin_manage_website_business_gallery",
        title: "businessGalleryContent",
        type: "item",
        icon: <SiReaddotcv size={20}/>,
        navLink: PanelPaths.admin.websiteBusinessGallery,
        roles: [],
        active: false,
        permissions: [],
    },
    {
        id: "admin_sendGoods",
        title: "HowToSendGoods",
        type: "item",
        icon: <FaShippingFast size={22}/>,
        navLink: PanelPaths.admin.deliveryMethods,
        roles: [],
        active: true,
        permissions: [ProjectPermissions.deliveryManagement],
    },
    {
        id: "admin_comments",
        title: "Comments",
        type: "item",
        icon: <FaComments size={22}/>,
        //navLink: `${PanelPaths.comments}?comment_status=pending`,
        navLink: PanelPaths.comments,
        roles: [],
        active: true,
        permissions: [ProjectPermissions.commentsManagement],
    },
    {
        id: "withdraw_requests",
        title: "withdrawRequests",
        type: "item",
        icon: <FaMoneyCheck size={22}/>,
        navLink: PanelPaths.admin.walletRequests,
        roles: [],
        active: true,
        permissions: [projectPermissions.withdrawRequestsManagement],
    },
    {
        id: "contactsRequests",
        title: "contactsRequests",
        type: "item",
        icon: <MdContactPhone size={22}/>,
        navLink: PanelPaths.admin.contactRequests,
        roles: [],
        active: true,
        permissions: [projectPermissions.contact],
    },
    {
        id: "ReservationRequest",
        title: "agency",
        type: "item",
        icon: <CgEye size={22}/>,
        navLink: PanelPaths.admin.ReservationRequest,
        roles: [],
        active: true,
        permissions: [projectPermissions.ReservationRequest],
    },
    {
        id: "logs",
        title: "logs",
        type: "item",
        icon: <BsCalendarEventFill size={22}/>,
        navLink: PanelPaths.admin.logs,
        roles: [],
        active: true,
        permissions: [ProjectPermissions.canViewLogs],
    },
    {
        id: "account",
        title: "account",
        type: "collapse",
        icon: <MdAccountBox size={22}/>,
        navLink: PanelPaths.userAccount,
        roles: [],
        active: true,
        permissions: [projectPermissions.editProfile],
    },
    {
        id: "redirects",
        title: "redirects",
        type: "item",
        icon: <BiLink size={22}/>,
        navLink: PanelPaths.seo.redirects,
        roles: [],
        active: true,
        permissions: [projectPermissions.seo],
    },
    {
        id: "seoPages",
        title: "pages",
        type: "item",
        icon: <MdOutlinePages size={22}/>,
        navLink: PanelPaths.seo.pages,
        roles: [],
        active: true,
        permissions: [projectPermissions.seo],
    },
    {
        id: "admin_field_maker",
        title: "FieldMaker",
        type: "item",
        icon: <AiOutlineForm size={22}/>,
        navLink: PanelPaths.admin.fieldMaker.fields,
        roles: [],
        active: true,
        permissions: [projectPermissions.fields, projectPermissions.formulas],
    },
    {
        id: "admin_variables",
        title: "Variables",
        type: "item",
        icon: <HiVariable size={22}/>,
        navLink: PanelPaths.admin.variables,
        roles: [],
        active: true,
        permissions: [projectPermissions.variables],
    }
]

export default adminPanelSideBar;


